import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn as TableHead} from "react-bootstrap-table";

class EmployeeTable extends React.Component {

  constructor() {
    super();
  }

  checkNull(cell, row, formatExtraData, rowIdx) {
    if (cell == null || cell == undefined || cell == "") {
      return 'NA';
    }
    else return cell;
  }


  render() {


    let attendanceTable = this.props.attendanceDetails.attendance;
    return (
      <div style={{paddingBottom: '20px', paddingTop: '10px'}}>

        <BootstrapTable

          height="250"
          data={attendanceTable} striped={false} hover={true} condensed={true}>
          <TableHead dataSort={true}
                     columnClassName="attendancerowX"
                     isKey={true} width={130} dataField="date">Date</TableHead>
          <TableHead dataSort={true}
                     columnClassName="attendancerowX"
                     dataFormat={this.checkNull}
                     width={110} dataField="startTime">In Time</TableHead>
          <TableHead dataSort={true}
                     columnClassName="attendancerowX"
                     dataFormat={this.checkNull}
                     width={110} dataField="endTime">Out Time</TableHead>

          <TableHead dataField="totalWorkingHour"
                     columnClassName="attendancerowX"
                     dataFormat={this.checkNull} dataSort={true} width={130}>Working Hours</TableHead>

        </BootstrapTable>

        <div>
        </div>
      </div>

    );
  }
}

EmployeeTable.propTypes = {};

export default EmployeeTable;





/** WEBPACK FOOTER **
 ** ./src/feature/attendance/TeamAttendance/EmployeeTable.js
 **/